import useAuthModalStore from 'features/securities/AuthModal/store';
import { useBondsModalStore } from 'global/TradingModal/RealTradingModal/ModalBonds/stores/useBondsModalStore';
import useTradingAccount from 'hooks/useTradingAccount';
import { modalUnavailableStore } from './store';

const useOnClickBuyFR = (symbol: string) => {
  const openBuyModal = useBondsModalStore((store) => store.openBuyModal);
  const showAuthModal = useAuthModalStore((store) => store.showModal);
  const showModalUnavailable = modalUnavailableStore((store) => store.show);
  const { tradingType, isRealTrading, isVirtualTrading } = useTradingAccount();

  const onClickBuy = () => {
    if (!tradingType) {
      showAuthModal({
        onRealLoginSuccess: () => openBuyModal(symbol),
        onVirtualLoginSuccess: () => showModalUnavailable(),
      });
    } else if (isRealTrading) {
      openBuyModal(symbol);
    } else if (isVirtualTrading) {
      showModalUnavailable();
    }
  };

  return onClickBuy;
};

export default useOnClickBuyFR;
